export default __webpack_public_path__ + "static/media/content.356df473.png";